import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import { FaArrowLeft, FaEye, FaEyeSlash } from 'react-icons/fa';

const Register = () => {
  const [username, setUsername] = useState('');
  const [fathername, setFathername] = useState('');
  const [mothername, setMothername] = useState('');
  const [schoolname, setSchoolname] = useState('');
  const [mobilenumber, setMobilenumber] = useState('');
  const [password, setPassword] = useState('');

  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showVideo, setShowVideo] = useState(false);



  const API = process.env.REACT_APP_API_URL || "https://api.moulirobots.com";

  // const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:1500";



  const navigate = useNavigate();

  const isWeakPassword = (pwd) =>
    pwd.length < 6 || !/[a-zA-Z]/.test(pwd) || !/\d/.test(pwd);

  const validatePassword = () => {
    if (!password) {
      setPasswordError('Password is required.');
      return false;
    }
    if (isWeakPassword(password)) {
      setPasswordError(
        'Password must be at least 6 characters and include letters and numbers.'
      );
      return false;
    }
    setPasswordError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validatePassword()) return;

    const data = {
      username,
      password,
      fathername,
      mothername,
      schoolname,
      mobilenumber,
    };

    try {
      const response = await fetch(`${API}/api/sign-up`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage(result.message || 'Registration successful!');
        setError('');
        navigate('/login');
      } else {
        setError(result.error || 'Signup failed.');
        setMessage('');
      }
    } catch (err) {
      setError('Server error. Please try again.');
      setMessage('');
    }
  };

  return (
    <div className="sign_home">
      <div className="card_sign">
        <div className="card_sign2">
          <form className="form_sign" onSubmit={handleSubmit}>
            <p id="heading_sign">Sign Up</p>

            {/* Username */}
            <div className="field_sign">
              <input
                type="text"
                className="input-field"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="field_sign">
              <input
                type="text"
                className="input-field"
                placeholder="Father Name"
                value={fathername}
                onChange={(e) => setFathername(e.target.value)}
                required
              />
            </div>

            <div className="field_sign">
              <input
                type="text"
                className="input-field"
                placeholder="Mother Name"
                value={mothername}
                onChange={(e) => setMothername(e.target.value)}
                required
              />
            </div>

            <div className="field_sign">
              <input
                type="text"
                className="input-field"
                placeholder="School Name"
                value={schoolname}
                onChange={(e) => setSchoolname(e.target.value)}
                list="school-options"
                required
              />
  
              <datalist id="school-options">
                <option value="Government School" />
                <option value="Private School" />
                <option value="International School" />
                <option value="Home School" />
                <option value="Other" />
              </datalist>
            </div>

            <div className="field_sign">
              <input
                type="tel"
                className="input-field"
                placeholder="Mobile Number"
                value={mobilenumber}
                onChange={(e) => setMobilenumber(e.target.value)}
                pattern="[0-9]{10}"
                required
              />
            </div>

            {/* Password */}
            <div className="field_sign password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                className="input-field"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {passwordError && <p className="error-text">{passwordError}</p>}
            {error && <p className="error-text">{error}</p>}
            {message && <p className="success-text">{message}</p>}

            <div className="btn_sign">
              <button className="button_sign1" type="submit">
                Sign Up
              </button>
            </div>
          </form>
        </div>
      </div>

      <button className="back_button" onClick={() => navigate('/')}>
        <FaArrowLeft />
      </button>
    </div>
  );
};

export default Register;
